<template>
    <b-container fluid class="py-3 flex-grow-1 d-flex flex-column">
        <section class="grid-filters">
            <b-row align-h="between" class="mb-3">
                <b-col class="pl-1 d-none d-md-block mb-3 text-right" v-if="!actionsMenuVisible">
                  <portal-target name="properties-subnav" />
                </b-col>
                <b-col
                        cols="12"
                        sm="12"
                        md="12"
                        lg="4"
                        class="order-0 d-sm-block mb-3 mb-lg-0"
                        :class="{'d-none': !showSearch}"
                >
                    <search-filter
                            :showSearch="showSearch"
                            v-model="query.search"
                    >
                    </search-filter>
                    <div class="mt-4" v-if="gridTitle">
                      <h4>{{ gridTitle }}</h4>
                    </div>
                </b-col>
                <b-col cols="12"
                       sm="12"
                       md="4"
                       lg="2"
                       class="text-left filters-top justify-content-between" >

                  <due-date-type-select :solid="false" class="flex-fill mr-2 mr-md-1 pt-0 mr-3" />

                </b-col>
                <b-col cols="12"
                     sm="12"
                     md="8"
                     lg="2"
                     class="text-left filters-top justify-content-between" >
                    <multiselect
                        class="flex-fill hide-tags"
                        v-model="filters.overdue.value"
                        :multiple="filters.overdue.multiple"
                        :options="filters.overdue.options"
                        :placeholder="filters.overdue.placeholder"
                        :hide-selected="true"
                        :value="filters.overdue.value"
                        selectLabel=""
                        :key="filters.overdue.field"
                    >
                      <template #caret="{ toggle }">
                        <caret-icon @mousedown.prevent.stop="toggle"></caret-icon>
                      </template>
                    </multiselect>
                </b-col>
                <b-col cols="12"
                       sm="12"
                       md="8"
                       lg="4"
                       class="text-left filters-top justify-content-between justify-content-lg-end"
                >
                    <span class="from-label mx-2 text-right d-none d-sm-block">Due between</span>
                    <date-picker
                            id="dueDateFilterFrom"
                            :mode="filters.fromDate.mode"
                            v-model="filters.fromDate.value"
                            :calendarIcon="true"
                            popoverAlign="left"
                    >
                    </date-picker>
                    <span class="to-label mx-2 d-none d-sm-block">and</span>
                    <date-picker
                            id="dueDateFilterTo"
                            class="ml-2 ml-sm-0"
                            :mode="filters.toDate.mode"
                            v-model="filters.toDate.value"
                            :calendarIcon="true"
                            popoverAlign="right"
                    >
                    </date-picker>
                </b-col>
            </b-row>
            <portal to="properties-subnav">
                <b-dropdown
                        no-caret
                        right
                        variant="outline-primary"
                        toggle-class="py-1 px-2"
                >
                    <template #button-content>
                        Actions
                        <font-awesome-icon
                                class="ml-1"
                                :icon="['fal', 'chevron-down']"
                                size="xs"
                        ></font-awesome-icon>
                    </template>
                    <b-dropdown-item
                            v-if="$can($perm.JOBS_MANAGE_JOB_REQUESTS, $perm.PERMISSION_TYPE_JOBS)"
                            @click="createNewJobRequest()"
                    >
                        <font-awesome-icon
                                :icon="['fal', 'plus']"
                        >
                        </font-awesome-icon>
                        New Job
                    </b-dropdown-item>
                    <b-dropdown-item
                            v-if="$can($perm.JOBS_MANAGE_JOB_REQUESTS, $perm.PERMISSION_TYPE_JOBS)"
                            @click="addToJob()"
                    >
                        <font-awesome-icon
                                :icon="['fal', 'list-ol']"
                        >
                        </font-awesome-icon>
                        Add to Job
                    </b-dropdown-item>
                    <b-dropdown-item
                            v-if="$can($perm.JOBS_MANAGE_JOB_REQUESTS, $perm.PERMISSION_TYPE_JOBS)"
                            @click="removeFromJob()"
                    >
                        <font-awesome-icon
                                :icon="['fal', 'trash']"
                        >
                        </font-awesome-icon>
                        Remove from Job
                    </b-dropdown-item>
                    <b-dropdown-item
                            @click="onClickDownloadCsv()"
                    >
                        <font-awesome-icon
                                :icon="['fal', 'download']"
                        >
                        </font-awesome-icon>
                        Download CSV
                    </b-dropdown-item>
                    <b-dropdown-item
                            :href="getExportAllUrl()"
                            target="_blank"
                    >
                        <font-awesome-icon
                                :icon="['fal', 'download']"
                        >
                        </font-awesome-icon>
                        Export All
                    </b-dropdown-item>
                </b-dropdown>
            </portal>
        </section>
        <b-row class="flex-grow-1 d-flex flex-column">
            <b-col class="flex-grow-1 d-flex flex-column">
                <b-row class="grid-count mb-3 justify-content-between align-items-baseline">
                    <b-col cols="8" class="d-flex align-items-baseline text-dark">
                        <span>
                            {{ count }} Results
                            <span class="font-weight-bold"
                                  v-if="selectedCount > 0"
                            >
                                | {{ selectedCount }} selected
                            </span>
                        </span>
                    </b-col>
                    <b-col cols="4" class="d-flex justify-content-end">
                        <reset-filters
                                @click="resetGridToDefaultOptions"></reset-filters>
                        <refresh-button
                                :spinning="refreshing"
                                @click="refresh"
                        ></refresh-button>
                    </b-col>
                </b-row>
              <div v-if="allFilters.length > 0" class="filters-all mb-2">
                <div class="filters-all-items">
                  <b-badge :key="filter.label"
                           @click="removeFilter(filter)"
                           pill
                           v-for="filter in allFilters"
                           variant="secondary"
                           class="mb-2"
                  >
                    {{ filter.label }}
                    <font-awesome-icon
                        :icon="['fal', 'times-circle']"
                    ></font-awesome-icon>
                  </b-badge>
                  <span
                      @click="resetFilters"
                      class="filters-reset small"
                  >Reset all</span>
                </div>
              </div>
                <div class="grid-wrapper flex-grow-1 d-flex">
                    <ag-grid-vue
                            :style="'width: ' + gridWidth +'%;'"
                            :cacheQuickFilter="cacheQuickFilter"

                            :columnDefs="columnDefs"
                            :columnTypes="columnTypes"
                            :defaultColDef="defaultColDef"

                            :floatingFilter="floatingFilter"
                            :gridOptions="gridOptions"
                            @gridReady="onGridReady"

                            :headerHeight="rowHeight"
                            :quickFilter="query.search"
                            :rowData="rowData"

                            :rowHeight="rowHeight"
                            @rowSelected="updateRowSelected"

                            :isExternalFilterPresent="isExternalFilterActive"
                            :doesExternalFilterPass="doesExternalFilterPass"

                            :rowSelection="rowSelection"
                            :side-bar="sideBarDef"

                            @cellClicked="onCellClicked"

                            :suppressExcelExport="suppressExcelExport"
                            class="ag-theme-balham"

                            @columnMoved="saveGridOptions"
                            @columnPinned="saveGridOptions"
                            @columnResized="saveGridOptions"
                            @columnVisible="saveGridOptions"
                            @filterChanged="saveGridOptions"
                            @sortChanged="saveGridOptions"
                    >
                    </ag-grid-vue>
                </div>
            </b-col>
        </b-row>

        <job-request-modal
                :node-ids="selected.nodeIds"
                :complianceTypeId="complianceTypeId"
                :jobRequestTypeId="jobRequestTypeId"
                :hasCatB="hasCatB"
                :propertyId="propertyId"
                :jobId="jobId"
                :show.sync="modals.jobRequest.visible"
                v-if="modals.jobRequest.visible"
                @submitted="refresh"
        ></job-request-modal>
    </b-container>
</template>


<script>
import { AgGridVue } from 'ag-grid-vue';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import { mapGetters } from 'vuex';
import debounce from 'lodash/debounce';
import { size, forEach, invert, toInteger } from 'lodash';
import {
  newAndRenewalsDefaultColDef as gridDefaultColDef,
  newAndRenewalsGridColumnTypes as columnTypes,
  newAndRenewalsGridColumns as gridColumns,
} from '@/services/Property/NewAndRenewalsListingGrid';
import CaretIcon from '@/components/Form/CaretIcon';
import GridMixin from '@/components/Grid/GridMixin';
import Property from '@/services/Property/Property';
import ResetFilters from '@/components/Grid/ResetFilters';
import RefreshButton from '@/components/Grid/RefreshButton';
import JobRequestModal from '@/components/Job/Modal/JobRequestModal';
import SearchFilter from '@/components/Grid/SearchFilter';
import DatePicker from '@/components/Form/DatePicker';
import AssessmentType from '@/services/Assessment/AssessmentType';
import JobRequest from '@/services/Job/JobRequest';
import FiltersOptionsMixin from '@/components/Grid/FiltersOptionsMixin';
import ActionFilter from '@/services/Action/ActionFilter';
import ActionStatus from '@/services/Action/ActionStatus';
import PropertyAssessmentTypeStatus from '@/services/Property/PropertyAssessmentTypeStatus';
import riskhub from '@/services/Riskhub/Riskhub';
import DueDateTypeSelect from '@/components/Nav/DueDateTypeSelect';

dayjs.extend(isBetween);
dayjs.extend(isSameOrAfter);

const FILTER_SET = 'SET';
const FILTER_DATE = 'DATE';
const FILTER_TEXT = 'TEXT';

export default {
  name: 'Programme',
  components: {
    JobRequestModal,
    AgGridVue,
    CaretIcon,
    ResetFilters,
    RefreshButton,
    SearchFilter,
    DatePicker,
    DueDateTypeSelect,
  },
  props: {
    title: {
      type: String,
    },
  },
  mixins: [
    GridMixin,
    FiltersOptionsMixin,
  ],
  data() {
    return {
      modelId: 'propertyId',
      defaultColDef: gridDefaultColDef,
      columnDefs: gridColumns,
      complianceTypeId: '',
      tenure: this.$store.getters.propertyTenure,
      dueDateType: this.$store.getters.dueDateType.value,
      jobRequestTypeId: '',
      propertyId: '',
      jobId: '',
      columnTypes,
      toDate: '',
      fromDate: '',
      hasCatB: 0,
      modals: {
        jobRequest: {
          visible: false,
        },
      },
      fieldTypes: {
        multiSelect: [FILTER_SET],
        datePicker: [FILTER_DATE],
      },
      filters: {
        overdue: {
          placeholder: 'Filter Due Dates',
          multiple: false,
          external: true,
          filterFunction: node => this.filterOverdue(node),
          options: [
            ActionFilter.FILTER_DATE_OVERDUE_FRA(),
            ActionFilter.FILTER_DATE_OVERDUE_1_30(),
            ActionFilter.FILTER_DATE_OVERDUE_31_60(),
            ActionFilter.FILTER_DATE_OVERDUE_61_90(),
            ActionFilter.FILTER_DATE_OVERDUE_OVER_90(),
            ActionFilter.FILTER_DATE_WITHIN_FRA(),
            ActionFilter.FILTER_DATE_WITHIN_1_30(),
            ActionFilter.FILTER_DATE_WITHIN_31_60(),
            ActionFilter.FILTER_DATE_WITHIN_61_90(),
            ActionFilter.FILTER_DATE_WITHIN_OVER_90(),
          ],
          mapping: {
            1: ActionFilter.FILTER_DATE_OVERDUE_FRA(),
            2: ActionFilter.FILTER_DATE_WITHIN_FRA(),
            4: ActionFilter.FILTER_DATE_OVERDUE_1_30(),
            5: ActionFilter.FILTER_DATE_OVERDUE_31_60(),
            6: ActionFilter.FILTER_DATE_OVERDUE_61_90(),
            7: ActionFilter.FILTER_DATE_OVERDUE_OVER_90(),
            8: ActionFilter.FILTER_DATE_WITHIN_1_30(),
            9: ActionFilter.FILTER_DATE_WITHIN_31_60(),
            10: ActionFilter.FILTER_DATE_WITHIN_61_90(),
            11: ActionFilter.FILTER_DATE_WITHIN_OVER_90(),
          },
          value: [],
          modalValue: [],
        },
        fromDate: {
          type: FILTER_DATE,
          placeholder: 'Due between',
          field: 'dueDateFrom',
          value: null,
        },
        toDate: {
          type: FILTER_DATE,
          placeholder: 'and',
          field: 'dueDateTo',
          value: null,
        },
        notRequired: {
          external: true,
          filterFunction: node => this.filterNotRequired(node),
          value: null,
          mapping: {
            1: 'Not Required',
          },
        },
      },
      previousRoute: null,
    };
  },
  activated() {
    this.runOptionsFn(true);

    // We only want grid refresh when the grid has been loaded previously, using this.gridApi as the determinant for this
    if (this.gridApi) {
      this.refresh();
    }
  },
  computed: {
    ...mapGetters({
      showSearch: 'propertyShowSearch',
      actionsMenuVisible: 'actionsMenuVisible',
    }),
    gridTitle() {
      if (this.title) {
        return this.title;
      }

      if (!this.hasQueryString()) {
        return false;
      }
      const { query } = this.$route;

      const { overdue, status } = query;

      // Get title for overdue param
      if (overdue) {
        return this.filters.overdue.mapping[overdue];
      }

      // Get title for status param
      if (status) {
        const label = ActionStatus.getLabelForSecondaryOrCompletionStatus(status);

        if (label) {
          return this.uppercaseFirst(label);
        }

        return this.uppercaseFirst(status);
      }

      // Otherwise return first item as title
      const firstItem = query[Object.keys(query)[0]];
      return firstItem;
    },
    assessmentTypes() {
      return this.filters.jobType.options;
    },
    jobTypeOptions() {
      return this.filters.jobType.options.map(row => row.assessmentType);
    },
    /**
     * This combines all the filters that are applied via external dropdowns
     * It is used mainly for visual purposes
     * * */
    allFilters() {
      const allFilters = [];

      Object.entries(this.filters)
        .forEach(([type, item]) => {
          if (!item.value) {
            return;
          }

          let value = item.value;
          if (item.type === FILTER_DATE) {
            const stringParts = type.split('Date');
            value = stringParts[0];
            value = `${value.charAt(0).toUpperCase() + value.substring(1)}: ${riskhub.formatDate(item.value)}`;
          }

          // If it's not an array, we push just the string with no index
          if (!Array.isArray(value)) {
            allFilters.push({
              type,
              index: 0,
              label: value,
            });
            return;
          }

          Object.values(item.value)
            .forEach((label, index) => {
              allFilters.push({
                type,
                index,
                label,
              });
            });
        });

      return allFilters;
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.previousRoute = from;
    });
  },
  watch: {
    '$store.getters.complianceTypeId': function (value) {
      this.complianceTypeId = value;
      this.refresh();
    },
    '$store.getters.propertyTenure': function (value) {
      this.tenure = value;
      this.refresh();
    },
    '$store.getters.dueDateType': function (value) {
      this.dueDateType = this.$store.getters.dueDateType.value;
      this.refresh();
    },
    'filters.overdue.value': function () {
      this.gridApi.onFilterChanged();
    },
    'filters.notRequired.value': function () {
      this.gridApi.onFilterChanged();
    },
    'filters.fromDate.value': function filtersDateFromValue(newDateFrom, oldDateFrom) {
      if (this.dateFrom !== oldDateFrom) {
        this.dateFrom = dayjs(newDateFrom).unix();

        this.refresh();
      }
    },
    'filters.toDate.value': function filtersDateFromValue(newDateTo, oldDateTo) {
      if (this.dateTo !== oldDateTo) {
        this.dateTo = dayjs(newDateTo).unix();

        this.refresh();
      }
    },
  },
  created() {
    this.complianceTypeId = this.$store.getters.complianceTypeId;
  },
  methods: {
    /**
     * Check if the current route has a query string present
     */
    hasQueryString() {
      const { query } = this.$route;

      return (query && size(query) > 0);
    },
    /**
     * Apply any parameters from the query string to the grid
     */
    postRefreshQueryParams() {
      const { query } = this.$route;

      if (this.hasQueryString()) {
        this.$nextTick(() => {
          forEach(query, (value, field) => {
            if (field === 'overdue') {
              this.filters.overdue.value = this.filters.overdue.mapping[value];
              return;
            }

            if (field === 'notRequired') {
              this.filters.notRequired.value = this.filters.notRequired.mapping[value];
              return;
            }

            this.onFilterChange({
              field,
              value,
              type: FILTER_SET,
            });
          });
        });
      }
    },
    isExternalFilterActive() {
      // If overdue is active, as it is the only filter based on conditions
      let active = false;
      Object.entries(this.filters)
        .forEach(([type, item]) => {
          if (!item.external) {
            return;
          }

          if (item.value && item.value.length > 0) {
            active = true;
          }
        });

      return active;
    },
    /**
     * Checks to see if all external filters pass (like being overdue)
     */
    doesExternalFilterPass(node) {
      let success = false;
      const filterPass = [];
      Object.entries(this.filters)
        .forEach(([type, item]) => {
          if (!item.external) {
            return;
          }

          if (item.filterFunction) {
            filterPass.push(item.filterFunction(node));
          }
        });

      success = filterPass.includes(true);

      // Incase it is undefined
      if (!success) {
        success = false;
      }

      return success;
    },
    /**
     * Checks each row of data if they are overdue
     * This is based on the dueDate and internalDueDate
     */
    filterOverdue(node) {
      const dueDateTypeFilter = this.dueDateType;
      const overdueFilter = this.filters.overdue.value;
      const now = dayjs();
      const dueDate = dayjs(node.data.dueDate);
      const pdd = dayjs(node.data.programDueDate);
      const hasDueDate = (node.data.dueDate && node.data.dueDate !== '0000-00-00');
      const hasPdd = (node.data.programDueDate && node.data.programDueDate !== '0000-00-00');
      const isCatB = node.data.catB;

      // Don't include Cat Bs
      if (isCatB || node.data.complianceStatus !== PropertyAssessmentTypeStatus.AVAILABLE()) {
        return false;
      }

      if (dueDateTypeFilter === 'programDueDate' && !hasPdd) {
        return false;
      }

      if (overdueFilter === ActionFilter.FILTER_DATE_OVERDUE_FRA()) {
        if (!hasDueDate && dueDateTypeFilter === 'dueDate') {
          return true;
        }

        if (hasPdd && dueDateTypeFilter === 'programDueDate') {
          return pdd.isBefore(now, 'day');
        }
        if (hasDueDate && dueDateTypeFilter === 'dueDate') {
          return dueDate.isBefore(now, 'day');
        }
      }

      if (overdueFilter === ActionFilter.FILTER_DATE_OVERDUE_1_30()) {
        if (!hasDueDate && dueDateTypeFilter === 'dueDate') {
          return true;
        }

        const dateStart = now.subtract(30, 'day');
        const dateEnd = now.subtract(1, 'day');

        if (hasPdd && dueDateTypeFilter === 'programDueDate') {
          return pdd.isBetween(dateStart, dateEnd, 'day', '[]');
        }
        if (hasDueDate && dueDateTypeFilter === 'dueDate') {
          return dueDate.isBetween(dateStart, dateEnd, 'day', '[]');
        }
      }

      if (overdueFilter === ActionFilter.FILTER_DATE_OVERDUE_31_60()) {
        const dateStart = now.subtract(60, 'day');
        const dateEnd = now.subtract(31, 'day');

        if (hasPdd && dueDateTypeFilter === 'programDueDate') {
          return pdd.isBetween(dateStart, dateEnd, 'day', '[]');
        }
        if (hasDueDate && dueDateTypeFilter === 'dueDate') {
          return dueDate.isBetween(dateStart, dateEnd, 'day', '[]');
        }
      }

      if (overdueFilter === ActionFilter.FILTER_DATE_OVERDUE_61_90()) {
        const dateStart = now.subtract(90, 'day');
        const dateEnd = now.subtract(61, 'day');

        if (hasPdd && dueDateTypeFilter === 'programDueDate') {
          return pdd.isBetween(dateStart, dateEnd, 'day', '[]');
        }
        if (hasDueDate && dueDateTypeFilter === 'dueDate') {
          return dueDate.isBetween(dateStart, dateEnd, 'day', '[]');
        }
      }

      if (overdueFilter === ActionFilter.FILTER_DATE_OVERDUE_OVER_90()) {
        const dateStart = now.subtract(90, 'day');

        if (hasPdd && dueDateTypeFilter === 'programDueDate') {
          return pdd.isBefore(dateStart, 'day');
        }
        if (hasDueDate && dueDateTypeFilter === 'dueDate') {
          return dueDate.isBefore(dateStart, 'day');
        }
      }

      if (overdueFilter === ActionFilter.FILTER_DATE_WITHIN_FRA()) {
        if (hasPdd && dueDateTypeFilter === 'programDueDate') {
          return pdd.isSameOrAfter(now, 'day');
        }
        if (hasDueDate && dueDateTypeFilter === 'dueDate') {
          return dueDate.isSameOrAfter(now, 'day');
        }
      }

      if (overdueFilter === ActionFilter.FILTER_DATE_WITHIN_1_30()) {
        const dateStart = now.add(30, 'day');

        if (hasPdd && dueDateTypeFilter === 'programDueDate') {
          return pdd.isBetween(now, dateStart, 'day', '[]');
        }
        if (hasDueDate && dueDateTypeFilter === 'dueDate') {
          return dueDate.isBetween(now, dateStart, 'day', '[]');
        }
      }

      if (overdueFilter === ActionFilter.FILTER_DATE_WITHIN_31_60()) {
        const dateStart = now.add(60, 'day');
        const dateEnd = now.add(31, 'day');

        if (hasPdd && dueDateTypeFilter === 'programDueDate') {
          return pdd.isBetween(dateStart, dateEnd, 'day', '[]');
        }
        if (hasDueDate && dueDateTypeFilter === 'dueDate') {
          return dueDate.isBetween(dateStart, dateEnd, 'day', '[]');
        }
      }

      if (overdueFilter === ActionFilter.FILTER_DATE_WITHIN_61_90()) {
        const dateStart = now.add(90, 'day');
        const dateEnd = now.add(61, 'day');

        if (hasPdd && dueDateTypeFilter === 'programDueDate') {
          return pdd.isBetween(dateStart, dateEnd, 'day', '[]');
        }
        if (hasDueDate && dueDateTypeFilter === 'dueDate') {
          return dueDate.isBetween(dateStart, dateEnd, 'day', '[]');
        }
      }

      if (overdueFilter === ActionFilter.FILTER_DATE_WITHIN_OVER_90()) {
        const dateStart = now.add(90, 'day');

        if (hasPdd && dueDateTypeFilter === 'programDueDate') {
          return pdd.isAfter(dateStart, 'day');
        }
        if (hasDueDate && dueDateTypeFilter === 'dueDate') {
          return dueDate.isAfter(dateStart, 'day');
        }
      }
      return false;
    },

    filterNotRequired(node) {
      const value = this.filters.notRequired.value;
      if (!value) {
        return false;
      }

      const { data } = node;
      if (data.catB) {
        return true;
      }

      if (data.complianceStatus === PropertyAssessmentTypeStatus.NOT_APPLICABLE()
        || data.complianceStatus === PropertyAssessmentTypeStatus.VOID()
        || data.complianceStatus === PropertyAssessmentTypeStatus.UNDER_REFURBISHMENT()
        || data.complianceStatus === PropertyAssessmentTypeStatus.MANAGING_AGENT()
        || data.complianceStatus === PropertyAssessmentTypeStatus.INCLUDED_IN_OTHER_RA()
      ) {
        return true;
      }

      return false;
    },

    createNewJobRequest() {
      this.jobRequestTypeId = JobRequest.NEW_JOB_REQUEST_ID();

      const selectedRows = this.getSelectedNodes();
      const hasJob = selectedRows.find(row => row.data.jobId !== null);
      const hasJobRequest = selectedRows.find(row => row.data.jobRequestId !== null);

      if (hasJob) {
        this.$notify({
          title: 'Selected property has job',
          text: 'One or more of the selected properties are already in a job',
          type: 'error',
        });

        return;
      }

      if (hasJobRequest) {
        this.$notify({
          title: 'Selected property has job request',
          text: 'One or more of the selected properties are already in a job request',
          type: 'error',
        });

        return;
      }

      this.hasCatB = !!(selectedRows.find(row => row.data.catB === 1));

      this.openModal('jobRequest');
    },
    addToJob() {
      this.jobRequestTypeId = JobRequest.ADDITION_TO_JOB_ID();

      const selectedRows = this.getSelectedNodes();
      const hasJob = selectedRows.find(row => row.data.jobId !== null);
      const hasJobRequest = selectedRows.find(row => row.data.jobRequestId !== null);

      if (hasJob) {
        this.$notify({
          title: 'Selected property has job',
          text: 'One or more of the selected properties are already in a job',
          type: 'error',
        });

        return;
      }

      if (hasJobRequest) {
        this.$notify({
          title: 'Selected property has job request',
          text: 'One or more of the selected properties are already in a job request',
          type: 'error',
        });

        return;
      }

      this.hasCatB = !!(selectedRows.find(row => row.data.catB === 1));

      this.openModal('jobRequest');
    },
    removeFromJob() {
      this.jobRequestTypeId = JobRequest.REMOVAL_FROM_JOB_ID();

      const selectedRows = this.getSelectedNodes();

      if (selectedRows.length > 1) {
        this.$notify({
          title: 'Multiple properties selected',
          text: 'When removing from a job, please select only one property',
          type: 'error',
        });

        return;
      }

      const selectedRow = selectedRows.find(row => row.jobId !== null);

      this.hasCatB = selectedRow.data.catB === 1;

      if (!selectedRow.data.jobId) {
        this.$notify({
          title: 'Property has no job',
          text: 'This property is not currently allocated to a job. Please select another property',
          type: 'error',
        });

        return;
      }

      this.jobId = selectedRow.data.jobId;
      this.propertyId = selectedRow.data.propertyId;

      this.openModal('jobRequest');
    },
    getAssessmentTypes() {
      return AssessmentType.list();
    },
    onClickDownloadCsv() {
      const processCellCallback = (params) => {
        const column = params.column.getColId();
        let { value } = params;

        switch (column) {
          case 'numberRange':
          case 'streetNumber':
            if (value) {
              value = `="${value}"`;
            }
            break;

          case 'tenure':
            if (value) {
              // Remove all kinds of line breaks
              value = value.replace(/(\r\n|\n|\r)/gm, '');
            }
            break;

          case 'dueDate':
          case 'programDueDate':
          case 'handoverDate':
            value = riskhub.formatDate(value, true) || 'N/A';
            break;
        }

        return value;
      };

      const onlySelected = this.getSelectedNodes().length > 0;
      const params = {
        processCellCallback,
        onlySelected,
      };

      this.gridApi.exportDataAsCsv(params);
    },

    getExportAllUrl() {
      const url = Property.getNewAndRenewalsExportUrl(
        this.complianceTypeId,
        this.dateTo,
        this.dateFrom,
        this.tenure,
        this.dueDateType,
      );

      return `${url}&token=${this.$store.getters.authToken}`;
    },

    async postGridReady(params) {
      this.setRowClasses();
      this.runOptionsFn();

      this.refresh();
    },

    /**
     * Async
     * Refreshes the table
     * Sets the grid options afterwards
     */
    async refresh() {
      if (this.refreshing) {
        return;
      }

      this.refreshing = true;
      // Wait until the data is set, external dropdown filters are set
      await this.refreshData();

      // Then we set the grid options
      // We set a timeout to disallow any future grid saving that happens
      // As filters are applied immediately after;
      setTimeout(() => {
        this.refreshing = false;
      }, 1);

      // Then we set the grid options
      this.setGridOptions();

      this.postRefresh();
    },

    /**
     * Call after every refresh
     * */
    postRefresh() {
      this.postRefreshQueryParams();
      this.updateRowSelected();
      // this.setDropdownFilters();
    },

    /**
     * Sets the rowdata with data from the server
     */
    refreshData() {
      this.refreshing = true;

      let rowData = [];
      return Property.getNewAndRenewals(
        this.complianceTypeId,
        this.dateTo,
        this.dateFrom,
        this.tenure,
        this.dueDateType,
      )
        .then((response) => {
          rowData = response.data.data;
        })
        .catch((error) => {
          this.$notify({
            duration: 5000,
            title: 'Error',
            text: 'We couldn\'t obtain the properties right now. Please try again later.',
            type: 'error',
          });
        })
        .finally(() => {
          this.rowData = rowData;
        });
    },

    /**
     *  Reset all filters
     */
    resetFilters() {
      this.resetting = true;

      Object.entries(this.filters)
        .forEach(([type, item]) => {
          if (item.type === FILTER_DATE) {
            this.filters[type].value = null;
            return;
          }
          if (type === 'notRequired') {
            this.filters[type].value = null;
            return;
          }
          this.filters[type].value = [];
        });

      this.$nextTick(() => {
        this.resetting = false;
      });

      this.gridApi.setQuickFilter(null);
      this.query.search = '';
      this.gridApi.setFilterModel(this.gridDefaults.filter);
    },

    /**
     * Remove filter by type + index
     * @param type
     * @param index
     */
    removeFilter({ type, index }) {
      if (this.filters[type].type === FILTER_DATE) {
        this.filters[type].value = null;
      } else if (!Array.isArray(this.filters[type].value)) {
        this.filters[type].value = [];
      } else {
        this.filters[type].value.splice(index, 1);
      }

      if (this.filters[type].type === FILTER_SET) {
        this.filterSet(this.filters[type]);
      } else if (this.filters[type].type === FILTER_TEXT) {
        this.filterText(this.filters[type]);
      }

      this.gridApi.onFilterChanged();
    },

    /**
     * Sets the grid up with:
     * Column state
     * Sort
     * Filters
     */
    setGridOptions() {
      const name = 'new-and-renewals';

      let gridState = this.$store.getters.gridState(name);
      let gridSort = this.$store.getters.gridSort(name);
      let gridFilter = this.$store.getters.gridFilter(name);

      if (!gridState) {
        gridState = this.gridDefaults.state;
      }

      if (!gridSort) {
        gridSort = this.gridDefaults.sort;
      }

      if (!gridFilter) {
        gridFilter = this.gridDefaults.filter;
      }

      this.columnApi.setColumnState(gridState);

      this.gridApi.setSortModel(gridSort);
      this.gridApi.setFilterModel(gridFilter);
      this.gridApi.onFilterChanged();
    },

    /**
     * Only allow to save the grid if it is not refreshing data
     * */
    saveGridOptions() {
      if (this.refreshing) {
        return false;
      }

      return this.saveOptions();
    },

    /**
     * Save the grid options (only allowed once per second)
     */
    saveOptions: debounce(function () {
      const name = 'new-and-renewals';
      const state = this.columnApi.getColumnState();
      const sort = this.gridApi.getSortModel();
      const filter = this.gridApi.getFilterModel();

      this.$store.dispatch('saveGridOptions', {
        name,
        state,
        sort,
        filter,
      });
    }, 1000),

    /**
     * Set row classes
     */
    setRowClasses() {
      const now = dayjs();
      const thirtyDays = dayjs().add(30, 'day');
      const ninetyDays = dayjs().add(90, 'day');

      this.gridOptions.getRowClass = ({ data }) => {
        if (!data || !data.dueDate || data.dueDate === '0000-00-00') {
          return '';
        }

        if (data.dueDate) {
          const dueDate = `${data.dueDate} 23:59:59`;

          if (now.isAfter(dayjs(dueDate))) {
            return 'red-row';
          }
        }

        return '';
      };
    },

    onCellClicked(node) {
      if (node.column.colDef.checkboxSelection) {
        return;
      }

      const { propertyId } = node.data;
      this.$router.push({
        name: 'property',
        params: {
          propertyId,
          fromRoute: 'programme',
        },
        query: {
          tab: 'programme',
        }
      });
    },

    /**
     * Opens a modal by name (in data -> modals.[name])
     */
    openModal(name) {
      const complianceTypeId = this.$store.getters.complianceTypeId;

      if (!complianceTypeId) {
        this.$notify({
          title: 'No Job Type selected',
          text: 'Please select a job type before requesting a new job',
          type: 'error',
        });

        return false;
      }

      if (this.refreshing) {
        this.$notify({
          title: 'Please wait..',
          text: 'Properties are currently being loaded, please try again',
          type: 'warn',
        });

        return false;
      }

      if (this.selectedIds.length === 0) {
        this.$notify({
          title: 'No properties selected',
          text: 'Please select at least one property.',
          type: 'warn',
        });

        return false;
      }

      this.modals[name].visible = true;
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
    .filters-top {
        display: flex;
        font-size: 14px;

        > div {
            margin-left: 0px;
        }

        /deep/ input#dueDateFilterTo,
        /deep/ input#dueDateFilterFrom {
            height: 34px;
        }

        /deep/ span.to-label,
        /deep/ span.from-label {
            font-size: 14px;
            padding: 8px 0;
        }

        /deep/ .calendar-icon {
            button {
                padding: 5px 14px;
            }
        }

        /deep/ span.from-label {
            min-width: 90px;
            width: 108px;
        }

        .multiselect {
            max-width: 250px;
            min-width: 200px;
            min-height: 34px;

            /deep/ &__input {
                font-size: 15px;
                border-color: $border-color;
            }
            /deep/ &__single {
                font-size: 15px;
            }

            /deep/ &__placeholder {
                display: none;
            }

            /deep/ &__caret {
                top: 5.5px !important;
            }

            /deep/ .multiselect__tags {
                min-height: 34px;

                /deep/ .multiselect__single {
                    margin: 3px;
                }
            }
        }
        /deep/ .multiselect__tags {
            border-color: $border-color;
            padding-top: 0.2rem !important;
            padding-bottom: 0.2rem !important;
            padding-left: 0.2rem !important;
            min-height: 14px;
        }
    }
    .filters-all {
        .filters-reset {
            color: #848484;
            cursor: pointer;
            text-decoration: underline;
        }

        .badge {
            margin-right: 0.75rem;
            font-size: 14px;
            padding: 5px 10px;
            font-weight: $font-weight-base;
            cursor: pointer;

            .fa-times-circle {
                margin-left: 5px;
            }
        }
    }
    @media screen and (max-width: 992px) {
        .filters-top {
            > div {

            }

            /deep/ span.from-label {
                width: 135px;
            }

            /deep/ input#dueDateFilterTo {

            }

            .multiselect {
                margin-left: 0;
                /deep/ &__input {
                    font-size: 12px;
                }
            }

            /deep/ .multiselect__tags {
                padding-left: 0.2rem !important;
            }
        }
    }
</style>
<style lang="scss">
    .grid-filters .filters-top {
        display: flex;
        font-size: 14px;

        > div {
            margin-right: 0px;
        }

        .btn {
            font-size: 14px;
        }
    }

    .filters-search {
        input {
            background: $grey-light;
            border-bottom-left-radius: 0;
            border-top-left-radius: 0;
            border-width: 0;

            &:focus {
                box-shadow: inset $input-btn-focus-box-shadow;
            }
        }
    }

    .filters-action.dropdown {
        > .btn {
            min-width: 230px;
            display: flex;
            justify-content: space-between;
        }
    }

    .grid {
        &-wrapper {
            max-height: 76vh;
            overflow: hidden;

            .action-item {
                overflow-y: auto;
            }
        }

        &-count {
            font-size: 14px;
        }
    }

    .filters-all {
        margin-top: 20px;
        margin-bottom: 10px;
        min-height: 23px;

        .filters-none {
            color: #848484;
            font-size: 14px;
        }

        .filters-reset {
            color: #848484;
            cursor: pointer;
            text-decoration: underline;
        }

        .badge {
            margin-right: 0.75rem;
            font-size: 12px;
            padding: 5px 10px;
            font-weight: $font-weight-base;
            cursor: pointer;

            .fa-times-circle {
                margin-left: 5px;
            }
        }
    }

    .ag-wide {
        min-width: 300px;
    }

    .green-row {
        color: $green;
    }

    .orange-row {
        color: $orange;

        &.red-row {
            color: $orange;
        }
    }

    .red-row {
        color: $red;
    }

    @media only screen and (max-width : 768px) {
        .grid-filters .filters-top {
            > div {
                margin-right: 0px;
            }
        }
    }
</style>
